import React from 'react';
import './taskIcon.css';

const TaskIcon = ({ icons, extraClass }) =>
    icons ? (
        <span className="task-icon">
            {icons.map(i => (
                <i key={`icon-${i}`} className={`fa fa-${i} ${extraClass || ''} ml10`} />
            ))}
        </span>
    ) : null;

export default TaskIcon;
